import { render, staticRenderFns } from "./OCodeMirror.vue?vue&type=template&id=cf60f7d4"
import script from "./OCodeMirror.vue?vue&type=script&lang=js"
export * from "./OCodeMirror.vue?vue&type=script&lang=js"
import style0 from "./OCodeMirror.vue?vue&type=style&index=0&id=cf60f7d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports